const t = (s) => {
  const c = /<(\w+)([^>/]*)\/\s*>/g;
  return s.replace(c, (r, o, n) => `<${o}${n}></${o}>`);
};
export {
  t as convertToBlockTags
};
//# sourceMappingURL=index.es9.js.map
